import {Component, Inject} from '@angular/core';
import {User} from "../../../../classes/user";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Dog} from "../../../../classes/dog";
import {kanFilesService} from "../../../services/services/files";
import {FileLog} from "../../../../classes/fileLog";
import {kanDogsService} from "../../../services/services/dogs";

@Component({
    selector: 'kan-file-log-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanFileLogDialog {
    public dog: Dog;
    public user: User;
    public notes: string;
    public isNew: boolean = true;
    public fileLog: FileLog = new FileLog();
    public file: File;

    public fileForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanFileLogDialog>,
                private formBuilder: FormBuilder,
                private filesService: kanFilesService,
                private dogsService: kanDogsService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.user) {
            this.user = this.data.user;
            this.fileLog.userId = this.user.id;
            this.fileLog.type = 'USER';
        }

        if (this.data && this.data.dog) {
            this.dog = this.data.dog;
            this.fileLog.dogId = this.dog.id;
            this.fileLog.type = 'DOG';
        }

        if (this.data && this.data.fileLog) {
            this.fileLog = JSON.parse(JSON.stringify(this.data.fileLog));
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        if (this.isNew) {
            this.fileForm = this.formBuilder.group({
                notes: new FormControl(this.fileLog.notes),
                file: new FormControl(this.file, [Validators.required])
            });
        } else {
            this.fileForm = this.formBuilder.group({
                notes: new FormControl(this.fileLog.notes),
                file: new FormControl(this.file)
            });
        }
    }

    public selectFile(event) {
        let input = document.createElement('input');
        input.type = 'file';
        input.click();
        input.addEventListener('change', (e) => {
            this.file = input.files[0];
            if (this.file) {
                this.fileForm.controls.file.setErrors(null);
            }
        });
    }

    public addFileLog(event) {

        this.filesService.addFileLog(this.fileLog, this.file)
            .then(() => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
            });
    }

    public updateFileLog(event) {

        this.filesService.updateFileLog(this.fileLog)
            .then((fileLog) => {

                this.dialogRef.close('update');
            })
            .catch((error) => {
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/file-log-dialog/component.ts